<template>
  <nav class="common-main-menu">
    <h2 class="a11y-hidden">메뉴 네비게이션</h2>
    <ul class="nav-list nav-scroll" >
      <li v-for="(menu, index) in menuItems" :key="'mainMenuItem_' + index" :data-index="menu.index" @click.prevent="()=>clickMenuItem(index)">
        <a href="#" :class="menu.index === +menuIndex ? 'on' : ''" :data-index="menu.index">{{menu.title}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { get } from 'lodash'
export default {
  name: 'CommonMainMenu',
  props: ['menuIndex', 'changeMenuFn', 'menuItems'],
  methods: {
    clickMenuItem (index) {
      const clickMenuItem = get(this.menuItems.filter((menu) => { return menu.index === +index }), ['0'], {})
      this.changeMenuFn(clickMenuItem)
    },
    moveMenuItem (index) {
      const clientWidth = document.body.clientWidth
      const mainMenuElements = document.querySelectorAll('.nav-list li')
      let targetEl = null
      for (let i = 0, len = mainMenuElements.length; i < len; i++) {
        if (+mainMenuElements[i].dataset.index === index) {
          targetEl = mainMenuElements[i]
        }
      }
      const rect = targetEl.getBoundingClientRect()
      let scrollLeft = (clientWidth / 2) - (rect.width / 2)
      let targetPosition = (targetEl.offsetLeft - targetEl.parentElement.scrollLeft) - scrollLeft
      targetEl.parentElement.scrollBy({
        behavior: 'smooth',
        top: 0,
        left: targetPosition
      })
    }
  },
  updated () {
    this.moveMenuItem(this.menuIndex || 0)
  },
  mounted () {
    this.moveMenuItem(this.menuIndex || 0)
  }
}
</script>

<style scoped>
  .nav-list {
    -ms-flex-pack: initial;
    justify-content: space-between !important;
  }
</style>
